












































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import Map from "./Map";
import { IPopUpInfo, PopupInfoType } from "./types";

@Component({
  name: 'v-info-pupup'
})
export default class PopUpUI extends Vue {
  @Prop({
    default: null
  }) title: string;
  @Prop({
    default: 'text'
  }) infoType: string; //PopupInfoType;
  @Prop({
    default: null
  }) info: any; //IPopUpInfo[] | string;
  @Prop({
    default: null
  }) containerStyle: string;
  @Prop({
    default: null
  }) okText: string;
  @Prop({
    default: null
  }) cancelText: string;
  @Prop({
    default: null
  }) map: Map;
  @Prop({
    default: {}
  }) state:{[key:string]:any};

  $this = null;
  FormIsValid: boolean = true;

  get locale() : string {
    return this.$store.getters.Locale;
  };

  FormValidateRules(item) : Function[] {
    let rules = [];
    if (item.data && item.data.rules) {
      for (let p in item.data.rules) {
        rules.push(item.data.rules[p]);
      }
    }
    return (rules.length>0) ? rules : null;
  }

  mounted() {
    this.$this = this;
    this.onMounted();
  }

  onMounted() {
    // to be overridden by application
  }

  closeMe() {
    this.map.hideInfoPopup(this);
  }

  doAction(action:string, data?:any) {
    this.$emit(action.toLowerCase(), data || this.map);
  }
}
